module.exports = __webpack_public_path__ + "assets/img/PrecisionMarketing.90bd38b2.png";